const MARQUEE = [
  "ESTD 2026",
  "KYC / AML COMPLIANT",
  "INTRODUCER MANDATE",
  "MEMBER-ONLY ACCESS",
  "PRIVATE CAPITAL MARKETS",
  "WRITTEN CONSENT PROTOCOL",
];

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="overflow-hidden border-y border-slate-800/70 bg-[#0D131C]/60 py-2">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span
            key={i}
            className="font-mono-ui text-[10px] uppercase tracking-[0.3em] text-slate-500 whitespace-nowrap flex items-center"
          >
            <span className="px-5">{item}</span>
            <span className="text-emerald-500/60">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
